import { render, staticRenderFns } from "./OddRow.vue?vue&type=template&id=104f0aaa&"
import script from "./OddRow.vue?vue&type=script&lang=js&"
export * from "./OddRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports